import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "@/pages/admin/AdminLayout";
import { api, formatINR } from "@/lib/api";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminProducts() {
  const [products, setProducts] = useState([]);

  const load = () => api.get("/products").then((r) => setProducts(r.data));

  useEffect(() => {
    load();
  }, []);

  const del = async (id) => {
    if (!window.confirm("Delete this product?")) return;
    try {
      await api.delete(`/products/${id}`);
      toast.success("Product deleted");
      load();
    } catch {
      toast.error("Could not delete");
    }
  };

  return (
    <AdminLayout
      title="Products"
      actions={
        <Link
          to="/admin/products/new"
          className="btn-primary inline-flex items-center gap-2 text-sm"
          data-testid="admin-new-product"
        >
          <Plus className="w-4 h-4" /> New Product
        </Link>
      }
    >
      <div className="card overflow-hidden" data-testid="admin-products-table">
        <div className="grid grid-cols-12 gap-4 px-4 py-3 border-b border-[#e0d8c8] text-xs uppercase tracking-[0.16em] text-[#6b6b6b]">
          <div className="col-span-5">Product</div>
          <div className="col-span-2">Category</div>
          <div className="col-span-2">Price</div>
          <div className="col-span-1">Stock</div>
          <div className="col-span-2 text-right">Actions</div>
        </div>
        {products.length === 0 && (
          <div className="p-6 text-sm text-[#6b6b6b]">No products yet. Create your first piece.</div>
        )}
        {products.map((p) => (
          <div key={p.id} className="grid grid-cols-12 gap-4 items-center px-4 py-3 border-b border-[#e0d8c8]" data-testid={`admin-product-row-${p.id}`}>
            <div className="col-span-5 flex items-center gap-3">
              <div className="w-12 h-14 bg-[#faf7f2] rounded-md overflow-hidden shrink-0 border border-[#e0d8c8]">
                {p.images?.[0] && <img src={p.images[0]} className="w-full h-full object-cover" alt="" />}
              </div>
              <div>
                <div className="text-sm font-medium">{p.name}</div>
                <div className="text-xs text-[#6b6b6b]">{p.brand}</div>
              </div>
            </div>
            <div className="col-span-2 text-sm capitalize">{p.category}</div>
            <div className="col-span-2 text-sm">{formatINR(p.price)}</div>
            <div className="col-span-1 text-sm">{p.stock}</div>
            <div className="col-span-2 flex justify-end gap-2">
              <Link to={`/admin/products/${p.id}`} className="w-8 h-8 flex items-center justify-center border border-[#e0d8c8] rounded-md hover:bg-[#faf7f2]" data-testid={`admin-edit-${p.id}`}>
                <Pencil className="w-4 h-4" />
              </Link>
              <button onClick={() => del(p.id)} className="w-8 h-8 flex items-center justify-center border border-[#e0d8c8] rounded-md hover:bg-[#faf7f2]" data-testid={`admin-delete-${p.id}`}>
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
